// Lib
import React from 'react';

// Components
import ProgressBar from '../uploader/ProgressBar';

import './FileProcessingIndicator.scss';

// Only rendered while the file is being processed server-side (its preview is generating).
// Upload/download byte progress lives in FileTransferToast, so the bar here is always indeterminate.
const FileProcessingIndicator = () => (
    <div className="FileProcessingIndicator">
        <ProgressBar percentageComplete={100} barbershop animate />
        <span className="progress-message">Processing</span>
    </div>
);

export default FileProcessingIndicator;
